module.exports = __webpack_public_path__ + "img/refund.82534ff6.svg";